import { api, unwrap, v4 as uuid } from '@saas-kit/lib';

import { MEMBERSHIP_ROLES, type MembershipRole } from '../members/api';

export { MEMBERSHIP_ROLES };
export type { MembershipRole };

export interface Invitation {
  id: string;
  tenant_id: string;
  email: string;
  // A system role slug or a custom tenant role slug.
  role: string;
  expires_at: string;
  invited_by_user_id: string;
  created_at: string;
  updated_at: string;
}

interface ListEnvelope {
  items: Invitation[];
}

function withIdempotency(): { headers: Record<string, string> } {
  return { headers: { 'Idempotency-Key': uuid() } };
}

export async function listInvitations(): Promise<Invitation[]> {
  const data = await unwrap<ListEnvelope>(api.get('/memberships/invitations'));
  return data.items;
}

export async function createInvitation(
  email: string,
  role: string,
): Promise<void> {
  await unwrap(api.post('/memberships/invitations', { email, role }, withIdempotency()));
}

export async function revokeInvitation(invitationId: string): Promise<void> {
  await unwrap(api.post(`/memberships/invitations/${invitationId}/revoke`));
}

export interface CreatedMember {
  id: string;
  tenant_id: string;
  user_id: string;
  role: MembershipRole;
  status: string;
  email: string;
  full_name: string | null;
}

export interface CreateMemberInput {
  email: string;
  // A system role slug or a custom tenant role slug.
  role: string;
  password: string;
  full_name?: string;
}

export async function createMember(input: CreateMemberInput): Promise<CreatedMember> {
  return unwrap<CreatedMember>(api.post('/memberships', input, withIdempotency()));
}
